import ditthiClient from './ditthiClient'
import bxlUtils from 'bxl-utils'
function imageSearch(
  from: number = 0,
  to: number = 50,
  formData: FormData,
  brandIds?: string[],
  categoryIds?: string[],
  merchantIds?: string[],
  onUploadProgress?: (total, loaded) => void,
) {
  return ditthiClient.post('/api/v1/search/image', formData, {
    params: {
      to: to,
      from: from,
      brand: brandIds,
      category: categoryIds,
      merchant: merchantIds,
    },
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: ({ total, loaded }) => {
      onUploadProgress && onUploadProgress(total, loaded)
    },
    paramsSerializer: params => {
      return bxlUtils.uri.stringify(params)
    },
  })
}

function getP13nSearchWithProductId(
  from: number = 0,
  to: number = 50,
  productId: string,
  brandIds?: string[],
  categoryIds?: string[],
  merchantIds?: string[],
) {
  return ditthiClient.get(`/api/v1/search/product/${productId}`, {
    params: {
      to: to,
      from: from,
      brand: brandIds,
      category: categoryIds,
      merchant: merchantIds,
    },
    paramsSerializer: params => {
      return bxlUtils.uri.stringify(params)
    },
  })
}

function getP13nSearchWithImageUrl(
  from: number = 0,
  to: number = 50,
  url: string,
  brandIds?: string[],
  categoryIds?: string[],
  merchantIds?: string[],
) {
  return ditthiClient.get(`/api/v1/search/url`, {
    params: {
      to: to,
      from: from,
      url: url,
      brand: brandIds,
      category: categoryIds,
      merchant: merchantIds,
    },
    paramsSerializer: params => {
      return bxlUtils.uri.stringify(params)
    },
  })
}

export { imageSearch, getP13nSearchWithProductId, getP13nSearchWithImageUrl }
